import axios from '@/plugins/axios'

export function getPunishmentOrder(params = {}) {
  return axios.get('punishment_orders', { params })
}

export function storePunishmentOrder(data) {
  return axios.post('punishment_orders', data)
}

export function destroyPunishmentOrder(id) {
  return axios.delete(`punishment_orders/${id}`)
}

export function updatePunishmentOrder(id, data) {
  return axios.put(`punishment_orders/${id}`, data)
}

export function editPunishmentOrder(id) {
  return axios.get(`punishment_orders/${id}/edit`)
}
